import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Upload } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await axios.post(`${API_URL}/api/admin/upload-image`, formData, {
    withCredentials: true,
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data.url;
};

export const ImageField = ({ value, onChange, testId }) => {
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      onChange(await uploadImage(file));
      toast.success('Imagen subida. Recuerda guardar los cambios.');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al subir imagen');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  return (
    <div className="space-y-3">
      <input
        type="text"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Pega aquí el enlace (URL) de la foto"
        className="w-full px-4 py-3 border border-[rgba(17,17,17,0.12)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1b3352]"
        data-testid={`config-image-url-${testId}`}
      />
      <div className="flex items-center gap-4">
        <label className="cursor-pointer px-4 py-2 bg-[#1b3352] text-white rounded-lg hover:bg-[#24426a] transition-colors flex items-center gap-2 text-sm">
          <Upload className="w-4 h-4" />
          <span>{uploading ? 'Subiendo...' : 'Subir foto'}</span>
          <input type="file" accept="image/*" onChange={handleFile} className="hidden" disabled={uploading} data-testid={`config-image-upload-${testId}`} />
        </label>
        {value && <img src={value} alt="Vista previa" className="h-16 w-auto rounded-lg border border-[rgba(17,17,17,0.1)]" data-testid={`config-image-preview-${testId}`} />}
      </div>
    </div>
  );
};
